<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div>
          <div class="label-input">Section Background</div>
          <div class="mb-5 group-item">
            <div class="mb-5">
              <label class="font-weight-bold">Background Desktop</label>
              <UploadImage
                @callback="obj => handleUploadImageBackground(obj)"
                :image="{ imageSrc: fields.background.img }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveImageBackground"
              />
            </div>
            <div class="mb-5">
              <label class="font-weight-bold">Background Mobile</label>
              <UploadImage
                @callback="obj => handleUploadImageBackgroundMobile(obj)"
                :image="{ imageSrc: fields.background.imgMobile }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveImageBackgroundMobile"
              />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <div class="">
                  <v-subheader class="pl-0"> Background Image Opacity </v-subheader>
                  <v-slider
                    v-model="fields.background.opacity"
                    class="align-center"
                    :step="0.1"
                    :max="1"
                    :min="0"
                    hide-details
                    thumb-label="always"
                  >
                  </v-slider>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3 mt-4">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.background.color"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields.background.color" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3 mt-4">
                  <input
                    type="color"
                    name="overlay-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.overlay.color"
                    @change="handleChangeOverlayColor"
                  />
                  <v-text-field v-model="fields.overlay.color" label="Overlay Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="">
                  <v-subheader class="pl-0"> Background Overlay Opacity </v-subheader>
                  <v-slider
                    v-model="fields.overlay.opacity"
                    class="align-center"
                    :step="0.1"
                    :max="1"
                    :min="0"
                    hide-details
                    thumb-label="always"
                  >
                  </v-slider>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields.textColor" label="Text Color" />
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">Content</div>
          <div class="group-item mb-5">
            <div class="mb-5">
              <label class="font-weight-bold">Title</label>
              <ckeditor :editor="editor" v-model="fields.content.title" :config="editorConfig" />
            </div>
            <v-row class="mb-5">
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="content-background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.content.backgroundColor"
                    @change="handleChangeContentBackgroundColor"
                  />
                  <v-text-field v-model="fields.content.backgroundColor" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="fields.content.contentAlign"
                  :items="['left', 'center', 'right']"
                  label="Content Align"
                />
              </v-col>
            </v-row>
            <div>
              <div class="d-flex justify-space-between align-center mb-3">
                <div class="label-input">List Items</div>
                <v-btn small text color="primary" @click="handleAddItem">
                  <v-icon size="16">mdi-plus</v-icon>
                  <span>Add Item</span>
                </v-btn>
              </div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, i) in fields.content.listItem" :key="i">
                  <v-expansion-panel-header>
                    <div class="d-flex justify-space-between align-center">
                      <span>Item {{ i + 1 }}</span>
                      <v-btn icon @click.stop="handleRemoveItem(i)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="">
                      <div class="mb-5">
                        <label class="font-weight-bold">Icon</label>
                        <UploadImage
                          @callback="obj => handleUploadIconItem(obj, i)"
                          :image="{ imageSrc: item.icon }"
                          :height="`250`"
                          :typeUpload="'image'"
                          @callbackDelete="handleRemoveIconItem(i)"
                        />
                      </div>
                      <div class="mb-5">
                        <label class="font-weight-bold">Text</label>
                        <v-text-field v-model="item.text" label="Item Text" />
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'BannerBasicB1',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Banner Basic B1 Section',
        textColor: '#000000',
        enableAnchor: false,
        padding: {
          top: true,
          bottom: true,
        },
        overlay: {
          color: '#000000',
          opacity: 0.5,
        },
        background: {
          color: '',
          img: '',
          imgMobile: '',
          opacity: 0,
        },
        content: {
          contentAlign: 'left',
          backgroundColor: '#281707',
          title: '',
          listItem: [
            {
              icon: '',
              text: '',
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionBannerBasicB1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImageBackground(obj) {
      this.fields.background.img = obj.imageSrc;
    },
    handleRemoveImageBackground() {
      this.fields.background.img = '';
    },
    handleUploadImageBackgroundMobile(obj) {
      this.fields.background.imgMobile = obj.imageSrc;
    },
    handleRemoveImageBackgroundMobile() {
      this.fields.background.imgMobile = '';
    },
    handleChangeBackgroundColor(event) {
      this.fields.background.color = event.target.value;
    },
    handleChangeOverlayColor(event) {
      this.fields.overlay.color = event.target.value;
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleAddItem() {
      this.fields.content.listItem.push({
        icon: '',
        text: '',
      });
    },
    handleRemoveItem(index) {
      this.fields.content.listItem.splice(index, 1);
    },
    handleUploadIconItem(obj, index) {
      this.fields.content.listItem[index].icon = obj.imageSrc;
    },
    handleRemoveIconItem(index) {
      this.fields.content.listItem[index].icon = '';
    },
    handleChangeContentBackgroundColor(event) {
      this.fields.content.backgroundColor = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
